export default __webpack_public_path__ + "static/media/edit-pencil.53940720.svg";